const FULL_HD_HEIGHT = 1080;
const FULL_HD_WIDTH = 1920;
// const HD_HEIGHT = 720;
// const HD_WIDTH = 1280;

const ScreenUtils = {
  height: document.documentElement.clientHeight || FULL_HD_HEIGHT,
  heightRatio:
    (document.documentElement.clientHeight || FULL_HD_HEIGHT) / FULL_HD_HEIGHT,
  width: document.documentElement.clientWidth || FULL_HD_WIDTH,
  widthRatio:
    (document.documentElement.clientWidth || FULL_HD_WIDTH) / FULL_HD_WIDTH,
};

export default ScreenUtils;
